/**
 * MarketingSpot Component
 */
(function(itxApp) {

    'use strict';

    /**
     * Render MSpots from AJAX request
     */
    var ItxMarketingSpotCmp = {
        bindings: {
            name: '@',
            compile: '<',
            model: '<'
        },
        controller: ItxMarketingSpotCmpCtrl,
        controllerAs: 'marketingSpotCtrl',
        template: '<div></div>'
    };

    ItxMarketingSpotCmpCtrl.$inject = ['$element', '$rootScope', '$scope', '$compile', '$cacheFactory', '$timeout'];

    function ItxMarketingSpotCmpCtrl($element, $rootScope, $scope, $compile, $cacheFactory, $timeout) {
        var _this = this,
            cache = $cacheFactory.get('ItxMarketingSpotCmpCtrl');

        _this.$onInit = function() {
            if (!_this.name) {
                return;
            }

            if (!cache) {
                cache = $cacheFactory('ItxMarketingSpotCmpCtrl');
            }

            var spots = cache.get(inditex.iSpotPrefix + _this.name);
            if (spots) {
                render(spots);
                return;
            }

            inditex.execute({
                'actions': [{
                    'action': 'marketing:marketingSpots',
                    'params': {
                        'storeId': inditex.iStoreId,
                        'languageId': inditex.iLangId,
                        'catalogId': inditex.iCatalogId,
                        'spot': inditex.iSpotPrefix + _this.name
                    }
                }],
                'onFinish': function(status, spots) {
                    if (status === 1) {
                        cache.put(inditex.iSpotPrefix + _this.name, spots);
                        render(spots);
                    }
                }
            });
        };

        function render(spots) {
           
            var hasSpot = spots.spots && spots.spots.length > 0;
            
            if (hasSpot) {
                //TODO This is a Fix for itx-marketing-spot executing twice in ProductPage. Try to get it out
                $('.comment').text('');
                
                _.each(spots.spots, function(spot) {

                    spot.value  = spot.value.replace(/\${text\(/g,"{{"); // jshint ignore:line
                    spot.value  = spot.value.replace(/'\)}/g,"'|t}}"); // jshint ignore:line


                
                    
                    if (spot.name.indexOf('Notification') > 0) {
                        _this.compile = true;
                    }
                    if (_this.name === 'DistantSaleContract') {
                        $timeout(function() {
                            $element.find('div').append($compile(spot.value)($scope.$parent.$parent.$parent));
                        });
                    } else {
                        if (!_this.compile) {
                            $element.find('div').append(spot.value);
                        } else {
  
                            $timeout(function() {
                                if (_this.model) {
                                    for (var obj in _this.model) { // jshint ignore:line
                                        $scope[obj] = _this.model[obj];
                                    }
                                }

                                $element.find('div').append($compile(spot.value)($scope));
                            });
                        }
                    }
                });

                $rootScope.$broadcast('itx-marketing-spot:rendered', {
                    spot: _this.name,
                    $element: $element
                });
            }
        }
    }

    angular.module('itxApp.common')
        .component('itxMarketingSpot', ItxMarketingSpotCmp);
   

    itxApp.common.ItxMarketingSpotCmp = ItxMarketingSpotCmp;
    itxApp.common.ItxMarketingSpotCmpCtrl = ItxMarketingSpotCmpCtrl;


})(window.itxApp);